module.exports = __webpack_public_path__ + "img/onlineAppointments.6d4d1c14.png";